module.exports = __webpack_public_path__ + "assets/img/preload_placeholder_lg.0fbd9e2b.gif";